module.exports = __webpack_public_path__ + "static/explain-programming-meta-image-814db677ea9781f7b0430ee68ce41245.jpg";